module.exports = __webpack_public_path__ + "img/digital1.74160387.png";